// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__jRgkk","loader":"Loader_loader__DwtSp","spin":"Loader_spin__ddwRw"};